import { Callback } from "game-common/models"

import { HudChip } from "./hud_chip"

// The way into the pack from an ember camp.
//
// Ember rooms suppress the control bar (see roomUpdated's suppressControlBar), which is where the
// inventory button normally lives -- so in a camp there was no way to open the pack at all except
// the keyboard shortcut, which a phone does not have. This chip stands in for that button, in the
// corner the camp HUD already owns, beside the map and players toggles.
export class EmberInventoryChip extends HudChip {
    constructor(onClick: Callback) {
        super({ glyph: "🎒", label: "ITEMS", onClick, toggle: true })
    }
}
